"use client";

import * as React from "react";
import type { MarqueeContextValue } from "./marquee.types";

export const MarqueeContext = React.createContext<MarqueeContextValue | null>(
  null,
);

/** Access marquee state from any component inside `<Marquee.Root>`. */
export function useMarquee(): MarqueeContextValue {
  const ctx = React.useContext(MarqueeContext);
  if (!ctx) throw new Error("useMarquee must be used within <Marquee.Root>");
  return ctx;
}
